import React, {Component, Children} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as tradeBookActions from './../../actions/tradeBookActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as activityActions from './../../actions/activityActions';
import * as reportActions from './../../actions/reportActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
import styles from './../TradeBook/TradeBook.less';
import { Card } from 'reactstrap';
import {getCountofTableRows} from './../../utils/utils'; //import
import {
  Grid,
  DragDropProvider,
  Table,
  TableHeaderRow,
  TableColumnReordering,
  ColumnChooser,TableColumnVisibility,SearchPanel,Toolbar} from '@devexpress/dx-react-grid-bootstrap4';
import {SortingState,IntegratedSorting,  SearchState, IntegratedFiltering} from '@devexpress/dx-react-grid';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import '../../theme/styles/reactstrap.css';
import i18next from 'i18next';
import numeral  from 'numeral';
import { withStyles } from '@material-ui/core/styles';
import { applyStyle,applyToHover,setDirection } from './../../utils/utils';
import MUIIconWithTooltip from '../../components/IconMaterialUI/MUIIconWithTooltip';

// const elementsData = [
//   {"classNames":"trdBkDropdown", "elementType":"normal", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"caret","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dropdown-menu","elementType":"normal", "applyTo":"all", "tagNames":"ul"},
//   {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
//   {"classNames":"form-control","elementType":"tag", "applyTo":"all", "tagNames":"input"},
//   {"classNames":"oi-eye","elementType":"tag", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dx-g-bs4-table","elementType":"normal", "applyTo":"all", "tagNames":"table"},
//   {"classNames":"dx-g-bs4-table-container","elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"dx-g-bs4-table-cell","elementType":"normal", "applyTo":"all", "tagNames":"td"},
//   {"classNames":"widgetwrapper", "elementType":"normal", "applyTo":"all", "tagNames":"div"},
//   {"classNames":"text-primary","elementType":"normal", "applyTo":"all", "tagNames":"span"},
//   {"classNames":"dropDownList","elementType":"tag", "applyTo":"all", "tagNames":"button"},
//   {"classNames":"dropdown-item", "elementType":"normal", "applyTo":"all", "tagNames":"button"}
// ];

const directionData=[
  {"classNames":"card-header", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"trdbody", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"refresh_icon", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"spotOrderRowsCount", "elementType":"normal", "applyTo":"single", "tagNames":"div"},
  {"classNames":"trdbookText", "elementType":"normal", "applyTo":"all", "tagNames":"span"}
];

let compareRate = (a, b) => {
  let result;
    if (numeral(a)._value < numeral(b)._value) {
      result = -1;
    }else{
      result = 1;
    }
    return result;
};

@connect(state => ({
  tradeBookColumns:state.dashboardRoot.dashboardReducer.tradeBookColumns,
  tradeBook:state.dashboardRoot.activityReducer.tradeBook,
  userDetail:state.auth.userDetail,
  getAllOrdersTrd:state.dashboardRoot.tradeBookReducer.getAllOrdersTrd,
  randomNoDB:state.dashboardRoot.activityReducer.randomNoDB,
  LoadFlag:state.dashboardRoot.activityReducer.LoadFlag,
  userDetail:state.auth.userDetail,
  actLogRandomNo:state.dashboardRoot.activityReducer.actLogRandomNo,
  language:state.dashboardRoot.commonReducer.language,
  sortingFlag:state.dashboardRoot.tradeBookReducer.sortingFlag,
  fontSize:state.auth.userDetail.fontSize,
  selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
  checkClickOnAddWidgetFlag:state.dashboardRoot.commonReducer.checkClickOnAddWidgetFlag,
  isSearch:state.dashboardRoot.commonReducer.isSearch,
  tradebookKey:state.dashboardRoot.activityReducer.tradebookKey,
  selectedLang:state.dashboardRoot.commonReducer.selectedLang,
  selectedCssColor:state.dashboardRoot.commonReducer.selectedCssColor,
}), {
  ...tradeBookActions,...dashboardActions,...activityActions,...reportActions,  ...commonActions, ...authActions
})

export default class SpotTableComponent extends Component {
  static propTypes = {
    tradeBookColumns:PropTypes.array,
    tradeBook:PropTypes.array,
    userDetail:PropTypes.object,
    LoadFlag:PropTypes.bool,
    setRefreshFlag:PropTypes.func,
    getInvoice:PropTypes.func,
    updateTrdBookCols:PropTypes.func,
    layoutChanged:PropTypes.func,
    userDetail:PropTypes.object,
    language:PropTypes.string,
    sortingFlag:PropTypes.boolean,
    changeSortingFlag:PropTypes.func,
    tradebookKey:PropTypes.string
  };
  state = {
    randomNo:0,
    spotrows:[],
    key:1,
    spotOrdcolumns:[],
    spotOrdColumnExtensions: [
      {columnName:'eventTime', width:180},
      {columnName:'deal', width:100},
      {columnName:'cmdtyPair', width:120},
      {columnName:'quantity', width:120, align:'right'},
      {columnName:'qtyType', width:120},
      {columnName:'rate', width:120, align:'right'},
      {columnName:'docNo', width:120},
      {columnName:'valDate' , width:120},
      {columnName:'trader', width:120},
      {columnName:'accDescription', width:150}
    ],
    spotOrdColumnExtensionsAR: [
      {columnName:'eventTime', width:180, align:'right'},
      {columnName:'deal', width:100, align:'right'},
      {columnName:'cmdtyPair', width:120, align:'right'},
      {columnName:'quantity', width:120, align:'left'},
      {columnName:'qtyType', width:120, align:'right'},
      {columnName:'rate', width:120, align:'left'},
      {columnName:'docNo', width:120},
      {columnName:'valDate', width:120, align:'right'},
      {columnName:'trader', width:120, align:'right'},
      {columnName:'accDescription', width:150, align:'right'}
    ],
    hiddenSpotColumnNames: [],
    spotSearchValue:'',
    integratedSortingColumnExtensions: [
        {columnName:'rate', compare:compareRate},
        {columnName:'quantity', compare:compareRate},
      ],
    spotColumnOrder: ['eventTime', 'deal', 'cmdtyPair', 'quantity', 'qtyType', 'rate', 'docNo', 'valDate', 'trader', 'accDescription', 'comments'],
    spotTrdRandomNo:0,
    refreshIconFlag:false,
    sortingFlagState:false,
    tableRowsCount:0,
    spotTrdCols:[]
  }

  constructor() {
    super();
    this.changeSpotColumnOrder = this.changeSpotColumnOrder.bind(this);
    this.spotColChangeSorting = this.spotColChangeSorting.bind(this);
    this.hiddenSoptColumnNamesChange = this.hiddenSoptColumnNamesChange.bind(this);
    this.changeSpotSearchValue = this.changeSpotSearchValue.bind(this);
  }

  componentWillMount(){
    let spotTrdCols = this.props.tradeBookColumns.spotColumnOrder;
    this.setState({spotTrdCols:spotTrdCols});
    var spotColsArr =[];
    for(let i=0 ; i< spotTrdCols.length ; i++){
      var obj ={};
      if(spotTrdCols[i] === "accDescription"){
        obj.name = spotTrdCols[i];
        obj.title = (i18next.t('account'));
        spotColsArr[i] = obj;
      }else{
        obj.name = spotTrdCols[i];
        obj.title = (i18next.t(spotTrdCols[i]));
        spotColsArr[i] = obj;
      }
    }
    this.setState({spotOrdcolumns:spotColsArr});
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    //const allCssStyleRules = this.props.selectedCssColorTheme;
    //applyStyle(thisComponent, allCssStyleRules, elementsData);
    setDirection(ReactDOM.findDOMNode(this),directionData,this.props.selectedLang);
    const hoverElementsClassNames = [
      {"elmToHover":thisComponent.getElementsByClassName('dropDownList')[0], "classNames":"dropDownList"},
      {"elmToHover":thisComponent.getElementsByClassName("dropdown-item")[0], "classNames":"dropdown-item"}
    ];
    //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    this.setState({refreshIconFlag:this.props.LoadFlag});
    this.setState({spotrows:this.props.tradeBook.tradeBookArray});
    this.setState({tableRowsCount:this.props.tradeBook.tradeBookArray.length});
    this.setState({spotTrdRandomNo:this.props.tradeBook.randomNo});
    this.setState({hiddenSpotColumnNames:this.props.tradeBookColumns.hiddenSpotColumnNames});
    let spotTrdCols = this.props.tradeBookColumns.spotColumnOrder;
    this.setState({spotTrdCols:spotTrdCols});
    var spotColsArr =[];
    for(let i=0 ; i< spotTrdCols.length ; i++){
      var obj ={};
      if(spotTrdCols[i] === "accDescription"){
        obj.name = spotTrdCols[i];
        obj.title = (i18next.t('account'));
        spotColsArr[i] = obj;
      }else{
        obj.name = spotTrdCols[i];
        obj.title = (i18next.t(spotTrdCols[i]));
        spotColsArr[i] = obj;
      }
    }
    this.setState({spotOrdcolumns:spotColsArr});
  }

  componentWillReceiveProps(nextProps){
    // if(this.props.selectedCssColorTheme !== nextProps.selectedCssColorTheme){
    //   const thisComponent = ReactDOM.findDOMNode(this);
    //   const allCssStyleRules = nextProps.selectedCssColorTheme;
    //   //applyStyle(thisComponent, allCssStyleRules, elementsData);
    //   const hoverElementsClassNames = [
    //     {"elmToHover":thisComponent.getElementsByClassName('dropDownListHover')[0], "classNames":"dropDownListHover"}
    //   ];
    //   //applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    // }
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(ReactDOM.findDOMNode(this),directionData,nextProps.selectedLang);
    }
    if(nextProps.language !== this.props.language){
      let spotTrdCols = nextProps.tradeBookColumns.spotColumnOrder;
      this.setState({spotTrdCols:spotTrdCols});
      var spotColsArr =[];
      for(let i=0 ; i< spotTrdCols.length ; i++){
        var obj ={};
        if(spotTrdCols[i] === "accDescription"){
          obj.name = spotTrdCols[i];
          obj.title = (i18next.t('account'));
          spotColsArr[i] = obj;
        }else{
          obj.name = spotTrdCols[i];
          obj.title = (i18next.t(spotTrdCols[i]));
          spotColsArr[i] = obj;
        }
      }
      this.setState({spotOrdcolumns:spotColsArr});
    }
    if(nextProps.tradebookKey === this.props.keyValue){
      if(nextProps.LoadFlag !== this.props.LoadFlag){
        this.setState({refreshIconFlag:nextProps.LoadFlag});
      }
    }
    // if(nextProps.LoadFlag !== this.props.LoadFlag){
    //
    //   }
    if(nextProps.tradebookKey === this.props.keyValue){
      if(nextProps.randomNoDB !== this.props.randomNoDB){
        var obj=nextProps.tradeBook.tradeBookArray;
        var spotrows = [];
        this.setState({spotrows:spotrows.concat(obj)});
        this.setState({tableRowsCount:nextProps.tradeBook.tradeBookArray.length});
        //this.setState({refreshIconFlag:false});
        this.props.setRefreshFlag(false,this.props.keyValue);
      }
    }

    if(this.state.spotTrdRandomNo!==nextProps.tradeBook.randomNo){
      var spotrows = [];
      var obj=nextProps.tradeBook.tradeBookArray;
      this.setState({spotrows:spotrows.concat(obj)});
      this.setState({tableRowsCount:nextProps.tradeBook.tradeBookArray.length});
      this.props.setRefreshFlag(false,this.props.keyValue);
      this.setState({spotTrdRandomNo:nextProps.tradeBook.randomNo});
    }
  }

  generateInvoice=(row)=>{
    try{
      var docNo=row.toString().split('""');
      var getdocType = row.toString().split('/');
      var docType=getdocType[0];
      if(docType !== 'PFC'){
        this.props.getInvoice(docNo,docType);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'generateInvoice', component:"SpotTableComponent"});
    }
  }

  changeSpotColumnOrder(newOrder) {
    try{
      this.setState({spotColumnOrder:newOrder});
      let trdCols =this.props.tradeBookColumns;
      trdCols.spotColumnOrder=newOrder;
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeSpotColumnOrder', component:"SpotTableComponent"});
    }
  }

  spotColChangeSorting(sorting) {
    try{
      this.setState({spotColsSorting:sorting});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'spotColChangeSorting', component:"SpotTableComponent"});
    }
  }

  hiddenSoptColumnNamesChange(hiddenSpotColumnNames){
    try{
      let trdCols =this.props.tradeBookColumns;
      trdCols.hiddenSpotColumnNames=hiddenSpotColumnNames;
      this.setState({hiddenSpotColumnNames:hiddenSpotColumnNames});
      this.props.updateTrdBookCols(trdCols);
      this.props.layoutChanged(1);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'hiddenSoptColumnNamesChange', component:"SpotTableComponent"});
    }
  };

  changeSpotSearchValue(value){
    try{
      var count=getCountofTableRows(this.state.spotrows,this.state.spotTrdCols,value);
      this.setState({tableRowsCount:count});
      this.setState({spotSearchValue:value});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'changeSpotSearchValue', component:"SpotTableComponent"});
    }
  }

  refreshComponentData =()=>{
    try{
      this.props.getTrdBook();
      this.props.setRefreshFlag(true,this.props.keyValue);
      this.setState({spotSearchValue:''});
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'refreshComponentData', component:"SpotTableComponent"});
    }
  }

  render() {
    const HighlightedCell = ({ value, style }) => (
      <Table.Cell>
        <span>
          { value.indexOf('PFC') === -1 ?
            <a className='trdeBookCell' title={i18next.t("invoiceDownldMsg")} onClick={()=>this.generateInvoice(value)}>
              {value}
            </a>
          : value}
        </span>
      </Table.Cell>
    );

    const Cell = props => {
      const { column } = props;
      if (column.name === "docNo") {
        return <HighlightedCell {...props} />;
      }
      if(column.name === "eventTime"){
        return <Table.Cell {...props} className="eventTimeCell"/>;
      }
      if(column.name === "valDate"){
        return <Table.Cell {...props} className="commonDateAR"/>;
      }
      return <Table.Cell {...props} />;
    };

    const rowStyle = theme => ({
      tableStriped: {
        '& tbody tr:nth-of-type(odd)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRow.background,
          //color: this.props.selectedCssColorTheme.listRow.color
        },
        '& tbody tr:nth-of-type(even)': {
          //backgroundColor: this.props.selectedCssColorTheme.listRowNext.background,
          //color: this.props.selectedCssColorTheme.listRow.color
        },
        '& thead tr': {
          //backgroundColor: this.props.selectedCssColorTheme.trdbookHeader.background,
        //  color: this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& thead tr th': {
          //backgroundColor: this.props.selectedCssColorTheme.trdbookHeader.background,
        //  color: this.props.selectedCssColorTheme.tableHeaderColor.color
        },
        '& .text-primary': {
          //color: this.props.selectedCssColorTheme.activeHeaderColor.color
        }
      },
    });

    const dropDownListColor =theme =>({
      dropDownListHoverMenu:{
        '& .dropdown-item':{
          // background:this.props.selectedCssColorTheme.dropDownList.background,
          // color:this.props.selectedCssColorTheme.dropDownList.color
        },
        '& :hover':{
          // background:this.props.selectedCssColorTheme.dropDownListHover.background,
          // color:this.props.selectedCssColorTheme.dropDownListHover.color
        }
      }
    });

    const TableComponentBase = ({ classes, ...restProps }) => (
      <Table.Table
        {...restProps}
        className={classes.tableStriped}
      />
    );

    const TableRow = props => {
      const { row } = props;
      if(row.deal === "BUY" || row.deal === "STOP BUY"){
        return <Table.Row  {...props}  className="blue" />;
      } else {
        return <Table.Row  {...props}  className="red" />;
      }
      return <Table.Row {...props} />;
    };

    const selectedfont_size ="fontSize_"+this.props.userDetail.fontSize;
    var tradeBookHeader ='';
    if(this.props.userDetail.fontSize == 'S'){
      tradeBookHeader = 'tradeBookHeaderSfont';
    } else if(this.props.userDetail.fontSize == 'N'){
      tradeBookHeader = 'tradeBookHeaderMfont'
    } else{
      tradeBookHeader = 'tradeBookHeaderLfont'
    }
    const searchPlaceholderMsg = {
      searchPlaceholder: (i18next.t('search'))+'...',
    };
    var NoDataMsg = {
      noData: '',
    }
    if (this.state.refreshIconFlag === true) {
      NoDataMsg.noData = '';
    } else {
      NoDataMsg.noData = (i18next.t('noDataAvlMsg'));
    }
    const NoDataCell = props => (
      <Table.NoDataCell {...props} className="noDataCell"  />
    );
    const ContainerColor = ({ classes, ...restProps }) => (
      <ColumnChooser.Container {...restProps} className={classes.dropDownListHoverMenu} />
    );
    const MenuColor = props => (
      <ColumnChooser.Item {...props} />
    );

    return (
      <div className={`${styles.trdbody} ${selectedfont_size} ${this.props.language}`} style={this.props.selectedLang.trdbody}>
        <div className={`${styles.spot_refresh_icon} refresh_icon`}>
          <span onClick={this.refreshComponentData} id="spotOrdRefreshBtn"><MUIIconWithTooltip icon={'Refresh'} style={this.props.selectedCssColorTheme.iconColor} title={i18next.t("refresh")}/></span>
        </div>

        <div className={`${styles.spotOrderRowsCount} spotOrderRowsCount`} >
          <span className="trdbookText">{i18next.t("count")}</span>: <span>{this.state.tableRowsCount}</span>
        </div>

        <div className={`${styles.tradeBookHeader} ${tradeBookHeader} ${selectedfont_size} ${this.props.selectedCssColor} spotTable `} id="spotTable" style={this.props.selectedLang.widgetwrapper}>
          <Card>
            <Grid  style={{height:'100%'}} rows={this.state.spotrows} columns={this.state.spotOrdcolumns}>
              <DragDropProvider />
              <SortingState onSortingChange={this.spotColChangeSorting} defaultSorting={[{columnName:'eventTime', direction:'desc'}]} id="spotOrdColChngSort" />
              <IntegratedSorting columnExtensions={this.state.integratedSortingColumnExtensions} />
              <SearchState value={this.state.spotSearchValue} onValueChange={this.changeSpotSearchValue} id="spotOrdChngSearchVal" />
              <IntegratedFiltering />
              <Table
                tableComponent={withStyles(rowStyle, {name:'TableComponent'})(TableComponentBase)}
                height="auto"
                columnAutoWidth={true}
                columnExtensions={this.props.language === 'AR' ? this.state.spotOrdColumnExtensionsAR : this.state.spotOrdColumnExtensions}
                cellComponent={Cell}
                messages={NoDataMsg}
                noDataCellComponent={NoDataCell}
                rowComponent={TableRow} />
              <TableColumnReordering order={this.state.spotColumnOrder} onOrderChange={this.changeSpotColumnOrder} id="spotOrdChngColOrd" />
              <TableHeaderRow showSortingControls />
              <TableColumnVisibility hiddenColumnNames={this.state.hiddenSpotColumnNames} onHiddenColumnNamesChange={this.hiddenSoptColumnNamesChange} id="spotOrdHiddenColChng" />
              <Toolbar />
              <SearchPanel messages={searchPlaceholderMsg} />
              <ColumnChooser containerComponent={withStyles(dropDownListColor, {name:'ContainerComponent'})(ContainerColor)} itemComponent={MenuColor} />
            </Grid>
          </Card>

          {this.state.refreshIconFlag === true ?
            <div id="overlay" >
              <i className="fa fa-spinner fa-spin spin-big"></i>
            </div>
          : null}
        </div>
      </div>
    );
  }
}
